/* Repair known vendor markup without replacing vendor controls or collecting data. */
(()=>{
 const watchedMenus=new WeakSet();
 function scanMenus(){document.querySelectorAll('details.mobile-menu').forEach(menu=>{
  if(watchedMenus.has(menu))return;watchedMenus.add(menu);
  const summary=menu.querySelector('summary');if(!summary)return;
  const label=()=>{const spanish=document.documentElement.lang.toLowerCase().startsWith('es');summary.setAttribute('aria-label',spanish?(menu.open?'Cerrar el menú de navegación':'Abrir el menú de navegación'):(menu.open?'Close navigation menu':'Open navigation menu'));};
  menu.addEventListener('toggle',label);label();
  menu.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu.open){event.preventDefault();menu.open=false;label();summary.focus();}});
 });}
 function start(){scanMenus();new MutationObserver(scanMenus).observe(document.body,{childList:true,subtree:true});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
(()=>{
 const voteSelector='a.stamped-thumbs-up,a.stamped-thumbs-down';
 const selector='img[src*="lantern.roeye.com/track.php"],video>img:not([alt]),.stamped-badge[aria-label],h3.stamped-review-header-title,textarea[name="g-recaptcha-response"],.rzm3-sizing-wrapper h4,.specification>.col-span-full>h4,'+voteSelector;
 function repair(el){
  if(el.matches(voteSelector)){
   const count=el.textContent.trim();
   const action=el.classList.contains('stamped-thumbs-up')?'Rate review as helpful':'Rate review as not helpful';
   const label=count?action+'. '+count+' votes':action;
   if(el.getAttribute('aria-label')!==label)el.setAttribute('aria-label',label);
  }
  if(el.matches('.rzm3-sizing-wrapper h4,.specification>.col-span-full>h4')){el.setAttribute('role','heading');el.setAttribute('aria-level','2');}
  if(el.matches('textarea[name="g-recaptcha-response"]')&&!el.hasAttribute('aria-label'))el.setAttribute('aria-label','Security verification response');
  if(el.matches('img[src*="lantern.roeye.com/track.php"]')&&!el.hasAttribute('alt'))el.alt='';
  else if(el.matches('video>img:not([alt])'))el.alt='Video preview';
  else if(el.matches('.stamped-badge[aria-label]')&&!el.hasAttribute('role'))el.setAttribute('role','img');
  else if(el.matches('h3.stamped-review-header-title')&&!el.textContent.trim()){
   const p=document.createElement('p');for(const a of el.attributes)p.setAttribute(a.name,a.value);el.replaceWith(p);
  }
 }
 function scan(node){if(node.nodeType!==1)return;if(node.matches(selector))repair(node);node.querySelectorAll(selector).forEach(repair);}
 function start(){scan(document.documentElement);new MutationObserver(records=>{for(const r of records){const vote=r.target.nodeType===1?r.target.closest(voteSelector):null;if(vote)repair(vote);for(const n of r.addedNodes)scan(n);}}).observe(document.body,{childList:true,subtree:true});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

/* Keep the accessible cart quantity aligned with the visible vendor count. */
(()=>{
 const watched=new WeakSet();
 function watch(el){
  if(watched.has(el))return;watched.add(el);
  const sync=()=>{const value=el.textContent.trim();if(!/^\d+$/.test(value))return;
   const spanish=document.documentElement.lang.toLowerCase().startsWith('es');
   const label=spanish?value+(value==='1'?' artículo':' artículos'):value+(value==='1'?' item':' items');
   if(el.getAttribute('aria-label')!==label)el.setAttribute('aria-label',label);
  };
  sync();new MutationObserver(sync).observe(el,{childList:true,characterData:true,subtree:true});
 }
 function scan(node){if(node.nodeType!==1)return;if(node.matches('cart-count'))watch(node);node.querySelectorAll('cart-count').forEach(watch);}
 function start(){scan(document.documentElement);new MutationObserver(records=>records.forEach(r=>r.addedNodes.forEach(scan))).observe(document.body,{childList:true,subtree:true});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
